import React from 'react';

import { Grid } from '@mui/material';
import classNames from 'classnames';

import './style.scss';

interface IProps {
  className?: string;
  children: React.ReactNode;
}

const FullWidthContainer = ({ children, className }: IProps) => (
  <Grid
    item
    className={classNames('FullWidthContainer', className)}
    xs={true}
    flexGrow={1}
  >
    {children}
  </Grid>
);

export default FullWidthContainer;
